import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { appendScript } from '../../utils/appendScript';
import { removeScript } from '../../utils/removeScript';
import McqFeedback from './feedback/mcq';
import SaSpeechFeedback from './feedback/saFeedback';
import LaFeedback from './feedback/laFeedback/';
import WordCloudFeedback from './feedback//wordCloudFeedback/';
import ClozeConversationFeedback from './feedback/clozeConversationFeedback';
import ClozeFeedback from './feedback/clozeFeedback';
import ClozePassage from './feedback/clozePassage/';
import MsFeedback from './feedback/ms/';
import LinkedFeedback from './feedback/linkedFeedback/';

const QuestionFeedback = ({
	leftFeedbackProps: { domain, qtype },
	feedback,
}) => {
	useEffect(() => {
		appendScript('viewFullQuestion');

		return () => {
			removeScript('viewFullQuestion');
		};
	}, []);

	let feedbackSection = {};

	if (feedback.length > 1) {
		feedbackSection = <LinkedFeedback />;
	} else {
		switch (qtype.toLowerCase()) {
			case 'mcq':
				feedbackSection = <McqFeedback />;
				break;
			case 'ms':
				feedbackSection = <MsFeedback />;
				break;
			case 'sa':
			case 'sasemantic':
			case 'sakeyword':
				if (domain === 'S') {
					feedbackSection = <SaSpeechFeedback />;
					break;
				} else {
					feedbackSection = <LaFeedback />;
					break;
				}
			case 'la':
			case 'ielts':
				if (domain === 'S') {
					feedbackSection = <SaSpeechFeedback />;
					break;
				} else {
					feedbackSection = <LaFeedback />;
					break;
				}
			case 'wordcloud':
				feedbackSection = <WordCloudFeedback />;
				break;
			case 'cloze_with_conversation':
				feedbackSection = <ClozeConversationFeedback />;
				break;
			case 'cloze':
				feedbackSection = <ClozeFeedback />;
				break;
			case 'cloze_with_passage':
				feedbackSection = <ClozePassage />;
				break;
			default:
				feedbackSection = <div></div>;
				break;
		}
	}

	return <span>{feedbackSection}</span>;
};

const mapStateToProps = (state) => {
	const {
		isFeedback,
		elementType,
		leftFeedbackProps,
		feedback,
	} = state.rootReducer.testPageDetails;

	return {
		isFeedback,
		elementType,
		leftFeedbackProps,
		feedback,
	};
};

export default connect(mapStateToProps)(QuestionFeedback);
